import { type CaptureOptions, snapdom } from '@zumer/snapdom';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';
import { IS_IOS_MOBILE, IS_MAIL_APP_IOS, IS_WEBVIEW, IS_WEBVIEW_FROM_UA } from 'reactApp/appHelpers/configHelpers';

export const NESTLE_HIDE_ON_EXPORT_CLASS = 'nestleHideOnExport';
export const NESTLE_MOBILE_CLASS = 'nestlePetsCardMobile';
export const NESTLE_ONLY_EXPORT_CLASS = 'nestleExportOnly';
export const NESTLE_FIX_IOS_CLASS = 'nestleFixIOS';
export const NESTLE_BLOB_LIMIT = 819200; // 800Kb

export const snapDomOptions: CaptureOptions = {
    exclude: [`.${NESTLE_HIDE_ON_EXPORT_CLASS}`, '.vkuiIcon--dropdown_20', '.vkuiIcon--chevron_down_24'],
    scale: Number(getFeature('nestle-card-scale')) || 0.6,
    embedFonts: true,
    backgroundColor: 'transparent',
    type: 'png',
    dpr: 2,
    placeholders: false,
};

/**
 * HTML to image - генерируем картинки мобильной и декстопной карточки
 *
 * @param isMobile мобилка
 * @param card DOM-елемент карточки
 * @returns блоб
 */
export async function generatePetsCardsBlobData(isMobile: boolean, card: HTMLElement) {
    if (browser.isSafari() || browser.isMobileSafari() || IS_MAIL_APP_IOS || ((IS_WEBVIEW_FROM_UA || IS_WEBVIEW) && IS_IOS_MOBILE)) {
        card.classList.add(NESTLE_FIX_IOS_CLASS);
    }
    // Клонируем карточку чтобы навесить/убрать мобильные стили и экспортировать в картинкую
    const clone = card.cloneNode(true) as HTMLElement;
    clone.style.position = 'absolute';
    clone.style.top = '-1000px';
    clone.style.left = '-1000px';
    clone.classList.add(NESTLE_ONLY_EXPORT_CLASS);

    // Взависимости от того на декстопе или мобилке - добавляем / убираем класс для стилей карточки из другой платформы.
    if (isMobile) {
        clone.classList.remove(NESTLE_MOBILE_CLASS);
    } else {
        clone.classList.add(NESTLE_MOBILE_CLASS);
    }

    document.body.appendChild(clone);

    const desktopCard: Blob | null = await snapdom.toBlob(isMobile ? clone : card, snapDomOptions);
    const mobileCard: Blob | null = await snapdom.toBlob(isMobile ? card : clone, snapDomOptions);

    document.body.removeChild(clone);

    return { mobileCard, desktopCard };
}
